import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useQueryStringParam = (paramKey: string) => {
  const { search } = useLocation()
  const params = useMemo(() => new URLSearchParams(search), [search])
  return params.get(paramKey) ?? ''
}
